import { useToastStore } from '@/stores';

export const useToast = () => {
  const addToast = useToastStore((s) => s.addToast);

  return {
    success: (msg: string) => addToast(msg, 'success'),
    error: (msg: string) => addToast(msg, 'error'),
    info: (msg: string) => addToast(msg, 'info'),
    warning: (msg: string) => addToast(msg, 'warning'),
    addToast,
  };
};